import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartnermin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#865748",
			d: "M11.667.667V8.46h-.92v-3.1L6.16 8.107V5.36L.667 8.66v6.673h14.666V.667h-3.666Zm-7.32 13.706h-.92v-2.746h.92v2.746Zm1.833 0h-.92v-2.746h.92v2.746Zm2.72-.793h-.92v-.913h.92v.913Zm0-1.833h-.92v-.92h.92v.92Zm1.833 1.833h-.92v-.913h.92v.913Zm0-1.833h-.92v-.92h.92v.92Zm1.834 1.833h-.92v-.913h.92v.913Zm0-1.833h-.92v-.92h.92v.92Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgPartnermin);
export { ForwardRef as ReactComponent };
